import React from 'react';

const FullscreenLoader = ({ message }: { message: string }) => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white text-lg font-semibold">
      <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mb-4"></div>
      {message}
    </div>
  );
};

export default FullscreenLoader;
